import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { ICompanyType } from 'modules/company-type';

import { ICompaniesModal, ICompany, ISingleCompany } from '../types/companies.types';

interface CompaniesState extends BaseDataReducerInitialState<ICompany> {
  perPage: number;
  selectedCompany: ICompany | null;
  editableCompany: ISingleCompany | null;
  currentModal: ICompaniesModal | null;
  availableTypes: ICompanyType[];
}

const { initialState, AC, reducer, thunks } = basedDataReducer<ICompany, CompaniesState>('app-companies');

const companiesState: CompaniesState = {
  ...initialState,
  perPage: 10,
  currentModal: null,
  selectedCompany: null,
  editableCompany: null,
  availableTypes: [],
};

export const companies = createSlice({
  name: 'companies',
  initialState: companiesState,
  reducers: {
    setAvailableTypes(state, action: PayloadAction<ICompanyType[]>) {
      state.availableTypes = action.payload;
    },
    setSelectedCompany(state, action: PayloadAction<ICompany | null>) {
      state.selectedCompany = action.payload;
    },
    setCompaniesModal(state, action: PayloadAction<ICompaniesModal | null>) {
      state.currentModal = action.payload;
    },
    setEditableCompany(state, action: PayloadAction<ISingleCompany | null>) {
      state.editableCompany = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as CompaniesState, action);
    });
  },
});
export const CompaniesAC = AC;
export const onCompaniesSort = thunks.onSort;
export const onCompaniesFilter = thunks.onFilter;
export const setCompaniesCurrentPage = AC.setCurrentPage;

export const { setSelectedCompany, setCompaniesModal, setEditableCompany, setAvailableTypes } = companies.actions;
